module.exports = __webpack_public_path__ + "static/media/Salesforce_name.96a5cf9b.svg";